(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initVariantForms(scope = document) {
    scope.querySelectorAll('form.bdu-product-form').forEach((form) => {
      if (form.dataset.bduReady === 'true') return;
      form.dataset.bduReady = 'true';
      const select = form.querySelector('[data-bdu-variant-select]');
      const button = form.querySelector('[data-bdu-add]');
      const root = form.closest('[data-bdu-product-root]') || form.closest('.bdu-scheme');
      const price = root?.querySelector('[data-bdu-price]');
      const update = () => {
        const option = select?.selectedOptions[0];
        if (!option) return;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (button) button.disabled = option.disabled;
      };
      select?.addEventListener('change', update);
      form.addEventListener('submit', () => {
        if (button && !button.disabled) {
          button.dataset.bduOriginal = button.textContent;
          button.setAttribute('aria-busy', 'true');
        }
      });
      update();
    });
  }

  function initLazyVideos(scope = document) {
    const videos = [...scope.querySelectorAll('.bdu-lazy-video')].filter((video) => !video.dataset.bduVideoReady);
    if (!videos.length) return;
    videos.forEach((video) => { video.dataset.bduVideoReady = 'true'; });
    if (reducedMotion.matches) return;
    const load = (video) => {
      if (video.dataset.bduSrc && !video.src) {
        video.src = video.dataset.bduSrc;
        video.load();
      }
      video.play().catch(() => {});
    };
    if (!('IntersectionObserver' in window)) return videos.forEach(load);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          load(entry.target);
          observer.unobserve(entry.target);
        } else if (!entry.target.autoplay) {
          entry.target.pause();
        }
      });
    }, { rootMargin: '300px' });
    videos.forEach((video) => observer.observe(video));
  }

  function initThemeToggles(scope = document) {
    scope.querySelectorAll('[data-bdu-theme-toggle]').forEach((button) => {
      if (button.dataset.bduReady === 'true') return;
      button.dataset.bduReady = 'true';
      button.addEventListener('click', () => {
        const enabled = document.documentElement.classList.toggle('bdu-bone-mode');
        button.setAttribute('aria-pressed', String(enabled));
        button.setAttribute('aria-label', enabled ? 'Switch Budology sections to dark theme' : 'Switch Budology sections to bone theme');
      });
    });
  }

  function initNewsletter(scope = document) {
    scope.querySelectorAll('form.bdu-newsletter__form').forEach((form) => {
      if (form.dataset.bduReady === 'true') return;
      form.dataset.bduReady = 'true';
      const email = form.querySelector('input[type="email"]');
      const feedback = form.querySelector('.bdu-feedback');
      const message = form.closest('[data-bdu-newsletter-error]')?.dataset.bduNewsletterError || 'Enter a complete email address.';
      const validate = (event) => {
        if (!email || email.validity.valid) return;
        if (event) event.preventDefault();
        if (feedback) feedback.textContent = message;
        email.focus();
      };
      form.addEventListener('submit', validate);
      email?.addEventListener('invalid', validate);
      email?.addEventListener('input', () => { if (feedback) feedback.textContent = ''; });
    });
  }

  function init(scope = document) {
    initVariantForms(scope);
    initLazyVideos(scope);
    initThemeToggles(scope);
    initNewsletter(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
